<template>
  <main-template>
    <v-container>
      <v-row align="center" class="mb-1">
        <v-col>
          <h1>
            <v-btn color="primary" x-small text @click="$router.go(-1)">
              <v-icon left>fa fa-angle-left</v-icon>
            </v-btn>
            Minhas Notificações
          </h1>
        </v-col>
      </v-row>

      <v-alert type="info" text dense class="mb-4">
        Escolha quais avisos você quer receber e por onde. Isso vale só para você: os outros
        gestores continuam recebendo conforme as escolhas deles. Tudo vem marcado até você
        desmarcar.
      </v-alert>

      <v-card outlined :loading="carregando">
        <v-simple-table>
          <thead>
            <tr>
              <th>Aviso</th>
              <th class="text-center" style="width: 140px">
                <v-icon small class="mr-1">mdi-email-outline</v-icon>
                E-mail
              </th>
              <th class="text-center" style="width: 160px">
                <v-icon small class="mr-1">mdi-bell-outline</v-icon>
                No sistema
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in preferencias" :key="item.tipo">
              <td class="py-3">
                <div class="font-weight-bold">{{ item.titulo }}</div>
                <div class="text-caption grey--text text--darken-1">{{ item.descricao }}</div>
              </td>
              <td class="text-center">
                <div class="d-flex justify-center">
                  <v-switch
                    v-if="item.canais.includes('email')"
                    v-model="item.email"
                    inset
                    dense
                    hide-details
                    class="mt-0"
                    :aria-label="`Receber por e-mail: ${item.titulo}`"
                  />
                  <span v-else class="grey--text">—</span>
                </div>
              </td>
              <td class="text-center">
                <div class="d-flex justify-center">
                  <v-switch
                    v-if="item.canais.includes('sistema')"
                    v-model="item.sistema"
                    inset
                    dense
                    hide-details
                    class="mt-0"
                    :aria-label="`Receber no sistema: ${item.titulo}`"
                  />
                  <span v-else class="grey--text">—</span>
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-card-actions class="px-4 pb-4">
          <span class="text-caption grey--text">
            "No sistema" é o aviso que aparece no sino, no topo da tela.
          </span>
          <v-spacer />
          <v-btn color="primary" :loading="salvando" :disabled="carregando" @click="salvar">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </main-template>
</template>

<script>
export default {
  name: "MinhasNotificacoesPage",
  data() {
    return {
      carregando: false,
      salvando: false,
      preferencias: [],
    };
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const resposta = await this.$services.notificacaoPreferenciasService.listar();
        this.preferencias = resposta.preferencias || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },

    async salvar() {
      this.salvando = true;
      try {
        const resposta = await this.$services.notificacaoPreferenciasService.salvar(
          this.preferencias.map(({ tipo, email, sistema }) => ({ tipo, email, sistema }))
        );
        this.preferencias = resposta.preferencias || this.preferencias;
        this.$toast.success("Preferências salvas.");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>
